import { isFunction } from "app/_helpers/jsHelper";
import React from "react";
import { Button } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";

import { useThrottle } from "app/_helpers/hooks";

function FormBtn({
  id,
  onSubmit,
  backUrl,
  backOnClick = false,
  backBtnTitle,
  className,
}) {
  const { goBack } = useHistory();

  const onClick = useThrottle(
    (e) => {
      if (isFunction(onSubmit)) onSubmit(e);
    },
    [onSubmit],
    1000
  );

  return (
    <div className={className !== undefined ? className : "mt-4 text-center"}>
      {backUrl ? (
        <Link to={backUrl || goBack} className="btn btn-secondary mr-2">
          {backBtnTitle || "Back"}
        </Link>
      ) : (
        <Button
          onClick={backOnClick || goBack}
          variant="secondary"
          className="mr-2"
        >
          {backBtnTitle || "Back"}
        </Button>
      )}
      <Button onClick={onClick} variant="primary" className="ml-2">
        {id ? "Update" : "Save"}
      </Button>
    </div>
  );
}

export default FormBtn;
